import classNames from 'classnames';
import React from 'react';

export function PhiloLogo({ className }: { className?: string }) {
  return (
    <svg
      className={classNames('logo', 'philo-logo', className)}
      viewBox="0 0 256 107"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Philo</title>
      <path
        d="M40.0838 21.2479C32.3695 20.8667 25.245 23.3818 19.6495 27.6216C17.7852 23.9513 14.0517 21.3246 8.40866 21.3246H2.33759C1.04633 21.3269 0 22.3497 0 23.6119V31.7871C0 33.0493 1.04633 34.1766 2.33759 34.1766C2.33759 34.1766 4.3803 33.9883 5.54315 35.1622C6.64893 36.2803 6.65844 37.4286 6.65844 39.2231V104.02C6.65844 105.282 7.70477 106.305 8.99603 106.305H18.7078C19.9991 106.305 21.0454 105.282 21.0454 104.02V75.3942C25.5993 78.4765 31.0307 80.171 36.8711 80.4616C55.1366 81.3704 69.4332 67.219 68.979 49.4879C68.6105 35.0739 55.7121 22.0196 40.079 21.2479H40.0838ZM54.8418 52.2517C54.183 60.3386 47.4794 66.889 39.2063 67.5328C28.6931 68.3487 19.9515 59.7993 20.791 49.5251C21.4521 41.4406 28.1533 34.8902 36.424 34.2464C46.9349 33.4281 55.6764 41.9752 54.8394 52.2517H54.8418Z"
        fill="#EBEAE9"
        className="shape"
      />
      <path
        d="M186.344 66.3032C185.254 65.2618 185.223 64.3413 185.223 62.3237V4.13046C185.223 2.86827 184.177 1.84551 182.886 1.84551H173.174C171.883 1.84551 170.836 2.86827 170.836 4.13046V67.935C170.836 74.7596 175.027 80.2896 183.478 80.2896H189.547C190.838 80.2896 191.884 79.2668 191.884 78.0046V70.6012C191.884 69.339 191.528 67.6328 189.547 67.3864C189.547 67.3864 187.447 67.3585 186.346 66.3032H186.344Z"
        fill="#EBEAE9"
        className="shape"
      />
      <path
        d="M147.18 21.5105H141.111C139.82 21.5105 138.774 22.5333 138.774 23.7955V31.9707C138.774 33.2329 139.82 34.2556 141.111 34.2556C141.111 34.2556 143.168 34.2161 144.322 35.3435C145.411 36.4081 145.435 37.5145 145.435 39.3555V77.9627C145.435 79.2249 146.483 80.2477 147.774 80.2477H157.484C158.775 80.2477 159.822 79.2249 159.822 77.9627V33.8628C159.822 27.0358 155.631 21.5082 147.18 21.5082V21.5105Z"
        fill="#EBEAE9"
        className="shape"
      />
      <path
        d="M255.96 49.4482C255.177 34.3833 242.652 22.1426 227.241 21.3802C209.241 20.4899 194.455 34.9412 195.366 52.5328C196.143 67.5977 208.666 79.8384 224.078 80.6055C242.084 81.5004 256.873 67.0445 255.96 49.4459V49.4482ZM242.434 52.2492C241.78 60.2547 235.145 66.74 226.955 67.3769C216.547 68.1858 207.893 59.7224 208.725 49.5505C209.379 41.5473 216.014 35.062 224.204 34.4251C234.61 33.6162 243.264 42.075 242.434 52.2492Z"
        fill="#EBEAE9"
        className="shape"
      />
      <path
        d="M148.15 15.8643C153.746 16.7615 158.514 12.101 157.593 6.6338C157.037 3.32375 154.304 0.652925 150.918 0.111322C145.325 -0.785925 140.56 3.87232 141.475 9.33949C142.029 12.6495 144.762 15.3204 148.148 15.8643H148.15Z"
        fill="#EBEAE9"
        className="shape"
      />
      <path
        d="M116.663 23.1029C113.788 21.9685 110.694 21.3642 107.32 21.2735C96.2382 20.976 89.8461 26.485 89.8461 26.485V4.16769C89.8461 2.9055 88.7997 1.88273 87.5085 1.88273H77.7967C76.5054 1.88273 75.4591 2.9055 75.4591 4.16769V78.0023C75.4567 79.2645 76.503 80.2896 77.7943 80.2896H87.5061C88.7974 80.2896 89.8437 79.2668 89.8437 78.0046V47.1984C89.8461 43.0027 92.0576 39.0836 95.7245 36.9009C107.184 30.0809 119.112 38.0376 119.112 48.6721V78.0046C119.112 79.2668 120.159 80.2896 121.45 80.2896H131.162C132.453 80.2896 133.499 79.2668 133.499 78.0046V50.0552C133.499 37.2403 127.706 27.4659 116.661 23.1029H116.663Z"
        fill="#EBEAE9"
        className="shape"
      />
    </svg>
  );
}
